import { useFormAnswers } from "@quillforms/renderer-core";
import { useEffect, useRef } from "react";

const LiveLogger = ({ blocks }: { blocks: any[] }) => {
    const { answers } = useFormAnswers();
    const lastLogged = useRef<Record<string, any>>({});

    type Answer = {
        value: any;
        label?: string;
        required?: boolean;
        blockType?: string;
    };

    const rawAnswers = (answers || {}) as Record<string, Answer>;

    useEffect(() => {
        if (!rawAnswers || Object.keys(rawAnswers).length === 0) return; // FULL GUARD

        Object.entries(rawAnswers).forEach(([blockId, answer]) => {
            const value = answer?.value;

            if (lastLogged.current[blockId] !== value) {
                lastLogged.current[blockId] = value;
                console.log(`🟣 Live Answer Updated — ${blockId}:`, value);
            }
        });
    }, [rawAnswers]);

    return null;
};

export default LiveLogger;